import React from 'react';
import { getDescriptionForCheckbox } from '../../../common/utils/api_utils';
import CustomRadio from '../../../common/ui/CustomRadio';
import * as actions from '../redux/actions';
import { useDispatch } from 'react-redux';

export const UtilityRouteConfig = ({ route, projectId, version, isReadOnly }) => {
  const dispatch = useDispatch();

  const toggleCheckbox = (event) => {
    const { name, value, isChecked } = event.target;
    route[name] = !route[name];
    route.projectId = projectId;
    route.version = version;
    route.settingType = name;
    dispatch(actions.enableDeveloperApis(route));
  };

  const renderCheckbox = (label, name) => {
    if (!route) {
      return '';
    }
    const description = getDescriptionForCheckbox(name, route[name]);
    return (
      <div className="form-check ml-5">
        <CustomRadio label={label} isRadio={false}>
          <input
            name={name}
            type="checkbox"
            className="form-check-input"
            checked={route[name]}
            onChange={isReadOnly ? null : toggleCheckbox}
            disabled={isReadOnly}
          />
        </CustomRadio>
        {description && <p>{description}</p>}
      </div>
    );
  };

  return (
    <div className="my-2 pb-3">
      <h5 className="bg-light border-0 p-10 rounded">
        <strong style={{ marginRight: '6px' }}>{route.method.split('_')[0]}: </strong>
        <span className="m-2"> {route.url}</span>
      </h5>
      <div className="px-2">
        <strong style={{ color: 'grey', marginLeft: '5px' }}>{route.urlDescription}</strong>
        <div className="row">{renderCheckbox('Enable', 'enable')}</div>
      </div>
    </div>
  );
};
